export default "__VITE_ASSET__058400cd__"